export default __webpack_public_path__ + "static/media/flux.8a8b8b5f.svg";